import { RolexProductPageV72024 } from './kontent/models/RolexProductPageV72024'
import { Article } from '@generated'
import { getRcpoModelPrimaryAttributes } from './get-rcpo-model-primary-attributes'

/**
 * Builds a descriptive alt text for Rolex product images
 * Format: "Rolex {title} in {material} with a {dial} dial, {bezel} bezel, and {bracelet} bracelet"
 */
export function getRolexProductAltText(
  product: Partial<RolexProductPageV72024>,
  fallback?: string,
): string {
  const parts: string[] = []
  const title = product.title?.value
  const modelCase = product.specifications_model_case?.value
  const dial = product.specifications_dial?.value
  const bezel = product.specifications_bezel?.value
  const bracelet = product.specifications_bracelet?.value

  if (!title) {
    return fallback || 'Rolex watch'
  }

  parts.push(`Rolex ${title}`)

  if (modelCase) {
    parts.push(`in ${modelCase}`)
  }

  const details: string[] = []
  if (dial) {
    details.push(`${dial} dial`)
  }
  if (bezel) {
    details.push(`${bezel} bezel`)
  }
  if (bracelet) {
    details.push(`${bracelet} bracelet`)
  }

  if (details.length > 0) {
    if (details.length === 1) {
      parts.push(`with a ${details[0]}`)
    } else if (details.length === 2) {
      parts.push(`with a ${details[0]} and ${details[1]}`)
    } else {
      const lastDetail = details.pop()
      parts.push(`with a ${details.join(', ')}, and ${lastDetail}`)
    }
  }

  return parts.join(' ') || fallback || `Rolex ${title} watch`
}

/**
 * Builds a descriptive alt text for RCPO product images
 * Format: "Rolex Certified Pre-Owned {modelName} {primaryAttributes}"
 */
export function getRCPOProductAltText(data: Article, fallback?: string): string {
  const modelName = data.modelName
  const primaryAttributes = getRcpoModelPrimaryAttributes(data)

  if (!modelName) {
    return fallback || 'Rolex Certified Pre-Owned watch'
  }

  if (primaryAttributes) {
    return `Rolex Certified Pre-Owned ${modelName} ${primaryAttributes}`
  }

  return fallback || `Rolex Certified Pre-Owned ${modelName} watch`
}
